import React, { useState, useEffect } from 'react';
import { Container, Card, Menu, Input,  Grid, Icon} from 'semantic-ui-react';

import { PageTitle } from '../common/PageTitle';
import { CardSong } from '../cards/CardSong';
import { ResultContainerpagesVCM } from '../search/ResultsContainerVCM';

export const BrowseVocalChamberMusic = () => {
  const url = '//localhost:1338/api/v1/songs/search?size=120';
  const [songs, setSongs] = useState([]);
  const size = 90;
  const [aliases, setAliases] = useState({});
  const [query, setQuery] = useState('*');
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(size);
  const [activeTab, setActiveTab] = useState('vocal_chamber_music_songs');
  const [searchTerm, setSearchTerm] = useState('');
  const tabs = [
    { index: 'vocal_chamber_music_song_cycles', name: 'Song Cycles', icon: 'book', color: 'yellow' },
    { index: 'vocal_chamber_music_songs', name: 'Songs', icon: 'music', color: 'green' }
  ];

  function handleTabClick(event, target) {
    const { name } = target;
    setActiveTab(name);
  }

  useEffect(() => {
    async function go() {
      const result = await fetch(url);
      const json = await result.json();
      console.debug(json);
    }
    go();
  }, []);

  useEffect(() => {
  const timer = setTimeout(() => {
    setQuery(searchTerm.trim() === '' ? '*' : searchTerm);
  }, 300); 

    return () => clearTimeout(timer);
  }, [searchTerm]);

  const menuItems = tabs.map((t, i) => {
    return (
      <Menu.Item name={t.index} active={activeTab === t.index} onClick={handleTabClick} key={i}>
        <Icon name={t.icon} color={t.color} /> {t.name}
      </Menu.Item>
    )
  });

  return (
    <React.Fragment>
      <PageTitle title='Vocal Chamber Music' name='vocal_chamber_music'>
      Browse our collection of vocal chamber music.
      </PageTitle>
      <Container id='songs'>
        <Grid>
          <Grid.Column width={4}>
            <Menu vertical secondary>
              <Menu.Item>
                <Input type='search' placeholder='Search ...' fluid value= {searchTerm} onChange={(e) => setSearchTerm(e.target.value)}/>
              </Menu.Item>
            </Menu> 
          </Grid.Column>
          <Grid.Column width={12}>
            <Menu tabular attached='top'>
              {menuItems}
            </Menu>
            <ResultContainerpagesVCM query={query} model={activeTab} aliases={aliases} start={start} end={end} size={size} />     
          </Grid.Column>
        </Grid>
      </Container>
    </React.Fragment>
  );
};